/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AntennaA,
    AntennaAFromJSON,
    AntennaAToJSON,
} from '../models/AntennaA';
import {
    type AntennaACreate,
    AntennaACreateFromJSON,
    AntennaACreateToJSON,
} from '../models/AntennaACreate';
import {
    type AntennaAUpdate,
    AntennaAUpdateFromJSON,
    AntennaAUpdateToJSON,
} from '../models/AntennaAUpdate';
import {
    type AntennaSortKey,
    AntennaSortKeyFromJSON,
    AntennaSortKeyToJSON,
} from '../models/AntennaSortKey';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';

export interface AntennasACreateAntennaARequest {
    antennaACreate: AntennaACreate;
}

export interface AntennasADeleteAntennaARequest {
    antennaAId: string;
}

export interface AntennasAListAntennasARequest {
    pageSize: number;
    vehicleDeviceId?: string | null;
    stationaryUnitId?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: AntennaSortKey;
}

export interface AntennasAListAntennasAByVehicleDeviceIdRequest {
    vehicleDeviceId: string;
}

export interface AntennasAListAntennasAMetadataRequest {
    pageSize: number;
}

export interface AntennasAReadAntennaARequest {
    antennaAId: string;
}

export interface AntennasAUpdateAntennaARequest {
    antennaAId: string;
    antennaAUpdate: AntennaAUpdate;
}

export interface AntennasAValidateCreateAntennaARequest {
    antennaACreate: AntennaACreate;
}

export interface AntennasAValidateUpdateAntennaARequest {
    antennaAId: string;
    antennaAUpdate: AntennaAUpdate;
}

/**
 * AntennasAApi - interface
 * 
 * @export
 * @interface AntennasAApiInterface
 */
export interface AntennasAApiInterface {
    /**
     * Creates request options for antennasACreateAntennaA without sending the request
     * @param {AntennaACreate} antennaACreate 
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasACreateAntennaARequestOpts(requestParameters: AntennasACreateAntennaARequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new ELOshield antenna A.
     * @summary Create an ELOshield antenna A
     * @param {AntennaACreate} antennaACreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasACreateAntennaARaw(requestParameters: AntennasACreateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AntennaA>>;

    /**
     * Create a new ELOshield antenna A.
     * Create an ELOshield antenna A
     */
    antennasACreateAntennaA(requestParameters: AntennasACreateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AntennaA>;

    /**
     * Creates request options for antennasADeleteAntennaA without sending the request
     * @param {string} antennaAId 
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasADeleteAntennaARequestOpts(requestParameters: AntennasADeleteAntennaARequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the antenna A with the given ID.
     * @summary Delete an ELOshield antenna A
     * @param {string} antennaAId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasADeleteAntennaARaw(requestParameters: AntennasADeleteAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the antenna A with the given ID.
     * Delete an ELOshield antenna A
     */
    antennasADeleteAntennaA(requestParameters: AntennasADeleteAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for antennasAListAntennasA without sending the request
     * @param {number} pageSize 
     * @param {string} [vehicleDeviceId] 
     * @param {string} [stationaryUnitId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {AntennaSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAListAntennasARequestOpts(requestParameters: AntennasAListAntennasARequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the A antennas present.
     * @summary List A antennas
     * @param {number} pageSize 
     * @param {string} [vehicleDeviceId] 
     * @param {string} [stationaryUnitId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {AntennaSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAListAntennasARaw(requestParameters: AntennasAListAntennasARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AntennaA>>>;

    /**
     * Lists all the A antennas present.
     * List A antennas
     */
    antennasAListAntennasA(requestParameters: AntennasAListAntennasARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AntennaA>>;

    /**
     * Creates request options for antennasAListAntennasAByVehicleDeviceId without sending the request
     * @param {string} vehicleDeviceId 
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAListAntennasAByVehicleDeviceIdRequestOpts(requestParameters: AntennasAListAntennasAByVehicleDeviceIdRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the A antennas present for the specified vehicle device ID.
     * @summary List A antennas by vehicle device ID
     * @param {string} vehicleDeviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAListAntennasAByVehicleDeviceIdRaw(requestParameters: AntennasAListAntennasAByVehicleDeviceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AntennaA>>>;

    /**
     * Lists all the A antennas present for the specified vehicle device ID.
     * List A antennas by vehicle device ID
     */
    antennasAListAntennasAByVehicleDeviceId(requestParameters: AntennasAListAntennasAByVehicleDeviceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AntennaA>>;

    /**
     * Creates request options for antennasAListAntennasAByVehicleDeviceToken without sending the request
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAListAntennasAByVehicleDeviceTokenRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * Lists all the A antennas present for the authenticated vehicle device.
     * @summary List A antennas by vehicle device
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAListAntennasAByVehicleDeviceTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AntennaA>>>;

    /**
     * Lists all the A antennas present for the authenticated vehicle device.
     * List A antennas by vehicle device
     */
    antennasAListAntennasAByVehicleDeviceToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AntennaA>>;

    /**
     * Creates request options for antennasAListAntennasAMetadata without sending the request
     * @param {number} pageSize 
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAListAntennasAMetadataRequestOpts(requestParameters: AntennasAListAntennasAMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Antenna A listing metadata
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAListAntennasAMetadataRaw(requestParameters: AntennasAListAntennasAMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Antenna A listing metadata
     */
    antennasAListAntennasAMetadata(requestParameters: AntennasAListAntennasAMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for antennasAReadAntennaA without sending the request
     * @param {string} antennaAId 
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAReadAntennaARequestOpts(requestParameters: AntennasAReadAntennaARequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the A antenna specified by the given ID.
     * @summary Get a single A antenna
     * @param {string} antennaAId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAReadAntennaARaw(requestParameters: AntennasAReadAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AntennaA>>;

    /**
     * Returns the A antenna specified by the given ID.
     * Get a single A antenna
     */
    antennasAReadAntennaA(requestParameters: AntennasAReadAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AntennaA>;

    /**
     * Creates request options for antennasAUpdateAntennaA without sending the request
     * @param {string} antennaAId 
     * @param {AntennaAUpdate} antennaAUpdate 
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAUpdateAntennaARequestOpts(requestParameters: AntennasAUpdateAntennaARequest): Promise<runtime.RequestOpts>;

    /**
     * Update the A antenna specified by the given ID.
     * @summary Update antenna A
     * @param {string} antennaAId 
     * @param {AntennaAUpdate} antennaAUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAUpdateAntennaARaw(requestParameters: AntennasAUpdateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AntennaA>>;

    /**
     * Update the A antenna specified by the given ID.
     * Update antenna A
     */
    antennasAUpdateAntennaA(requestParameters: AntennasAUpdateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AntennaA>;

    /**
     * Creates request options for antennasAValidateCreateAntennaA without sending the request
     * @param {AntennaACreate} antennaACreate 
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAValidateCreateAntennaARequestOpts(requestParameters: AntennasAValidateCreateAntennaARequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new A antenna without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate an ELOshield antenna A
     * @param {AntennaACreate} antennaACreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAValidateCreateAntennaARaw(requestParameters: AntennasAValidateCreateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new A antenna without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an ELOshield antenna A
     */
    antennasAValidateCreateAntennaA(requestParameters: AntennasAValidateCreateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for antennasAValidateUpdateAntennaA without sending the request
     * @param {string} antennaAId 
     * @param {AntennaAUpdate} antennaAUpdate 
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAValidateUpdateAntennaARequestOpts(requestParameters: AntennasAValidateUpdateAntennaARequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given A antenna, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate A antenna update
     * @param {string} antennaAId 
     * @param {AntennaAUpdate} antennaAUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AntennasAApiInterface
     */
    antennasAValidateUpdateAntennaARaw(requestParameters: AntennasAValidateUpdateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given A antenna, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate A antenna update
     */
    antennasAValidateUpdateAntennaA(requestParameters: AntennasAValidateUpdateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class AntennasAApi extends runtime.BaseAPI implements AntennasAApiInterface {

    /**
     * Creates request options for antennasACreateAntennaA without sending the request
     */
    async antennasACreateAntennaARequestOpts(requestParameters: AntennasACreateAntennaARequest): Promise<runtime.RequestOpts> {
        if (requestParameters['antennaACreate'] == null) {
            throw new runtime.RequiredError(
                'antennaACreate',
                'Required parameter "antennaACreate" was null or undefined when calling antennasACreateAntennaA().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/antennas_a/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AntennaACreateToJSON(requestParameters['antennaACreate']),
        };
    }

    /**
     * Create a new ELOshield antenna A.
     * Create an ELOshield antenna A
     */
    async antennasACreateAntennaARaw(requestParameters: AntennasACreateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AntennaA>> {
        const requestOptions = await this.antennasACreateAntennaARequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AntennaAFromJSON(jsonValue));
    }

    /**
     * Create a new ELOshield antenna A.
     * Create an ELOshield antenna A
     */
    async antennasACreateAntennaA(requestParameters: AntennasACreateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AntennaA> {
        const response = await this.antennasACreateAntennaARaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for antennasADeleteAntennaA without sending the request
     */
    async antennasADeleteAntennaARequestOpts(requestParameters: AntennasADeleteAntennaARequest): Promise<runtime.RequestOpts> {
        if (requestParameters['antennaAId'] == null) {
            throw new runtime.RequiredError(
                'antennaAId',
                'Required parameter "antennaAId" was null or undefined when calling antennasADeleteAntennaA().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/antennas_a/{antenna_a_id}`;
        urlPath = urlPath.replace('{antenna_a_id}', encodeURIComponent(String(requestParameters['antennaAId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the antenna A with the given ID.
     * Delete an ELOshield antenna A
     */
    async antennasADeleteAntennaARaw(requestParameters: AntennasADeleteAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.antennasADeleteAntennaARequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the antenna A with the given ID.
     * Delete an ELOshield antenna A
     */
    async antennasADeleteAntennaA(requestParameters: AntennasADeleteAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.antennasADeleteAntennaARaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for antennasAListAntennasA without sending the request
     */
    async antennasAListAntennasARequestOpts(requestParameters: AntennasAListAntennasARequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling antennasAListAntennasA().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['vehicleDeviceId'] != null) {
            queryParameters['vehicle_device_id'] = requestParameters['vehicleDeviceId'];
        }

        if (requestParameters['stationaryUnitId'] != null) {
            queryParameters['stationary_unit_id'] = requestParameters['stationaryUnitId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/antennas_a/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the A antennas present.
     * List A antennas
     */
    async antennasAListAntennasARaw(requestParameters: AntennasAListAntennasARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AntennaA>>> {
        const requestOptions = await this.antennasAListAntennasARequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AntennaAFromJSON));
    }

    /**
     * Lists all the A antennas present.
     * List A antennas
     */
    async antennasAListAntennasA(requestParameters: AntennasAListAntennasARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AntennaA>> {
        const response = await this.antennasAListAntennasARaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for antennasAListAntennasAByVehicleDeviceId without sending the request
     */
    async antennasAListAntennasAByVehicleDeviceIdRequestOpts(requestParameters: AntennasAListAntennasAByVehicleDeviceIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleDeviceId'] == null) {
            throw new runtime.RequiredError(
                'vehicleDeviceId',
                'Required parameter "vehicleDeviceId" was null or undefined when calling antennasAListAntennasAByVehicleDeviceId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/antennas_a/vehicle_device/{vehicle_device_id}`;
        urlPath = urlPath.replace('{vehicle_device_id}', encodeURIComponent(String(requestParameters['vehicleDeviceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the A antennas present for the specified vehicle device ID.
     * List A antennas by vehicle device ID
     */
    async antennasAListAntennasAByVehicleDeviceIdRaw(requestParameters: AntennasAListAntennasAByVehicleDeviceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AntennaA>>> {
        const requestOptions = await this.antennasAListAntennasAByVehicleDeviceIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AntennaAFromJSON));
    }

    /**
     * Lists all the A antennas present for the specified vehicle device ID.
     * List A antennas by vehicle device ID
     */
    async antennasAListAntennasAByVehicleDeviceId(requestParameters: AntennasAListAntennasAByVehicleDeviceIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AntennaA>> {
        const response = await this.antennasAListAntennasAByVehicleDeviceIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for antennasAListAntennasAByVehicleDeviceToken without sending the request
     */
    async antennasAListAntennasAByVehicleDeviceTokenRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/antennas_a/vehicle_device`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the A antennas present for the authenticated vehicle device.
     * List A antennas by vehicle device
     */
    async antennasAListAntennasAByVehicleDeviceTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AntennaA>>> {
        const requestOptions = await this.antennasAListAntennasAByVehicleDeviceTokenRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AntennaAFromJSON));
    }

    /**
     * Lists all the A antennas present for the authenticated vehicle device.
     * List A antennas by vehicle device
     */
    async antennasAListAntennasAByVehicleDeviceToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AntennaA>> {
        const response = await this.antennasAListAntennasAByVehicleDeviceTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for antennasAListAntennasAMetadata without sending the request
     */
    async antennasAListAntennasAMetadataRequestOpts(requestParameters: AntennasAListAntennasAMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling antennasAListAntennasAMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/antennas_a/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Antenna A listing metadata
     */
    async antennasAListAntennasAMetadataRaw(requestParameters: AntennasAListAntennasAMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.antennasAListAntennasAMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Antenna A listing metadata
     */
    async antennasAListAntennasAMetadata(requestParameters: AntennasAListAntennasAMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.antennasAListAntennasAMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for antennasAReadAntennaA without sending the request
     */
    async antennasAReadAntennaARequestOpts(requestParameters: AntennasAReadAntennaARequest): Promise<runtime.RequestOpts> {
        if (requestParameters['antennaAId'] == null) {
            throw new runtime.RequiredError(
                'antennaAId',
                'Required parameter "antennaAId" was null or undefined when calling antennasAReadAntennaA().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/antennas_a/{antenna_a_id}`;
        urlPath = urlPath.replace('{antenna_a_id}', encodeURIComponent(String(requestParameters['antennaAId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the A antenna specified by the given ID.
     * Get a single A antenna
     */
    async antennasAReadAntennaARaw(requestParameters: AntennasAReadAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AntennaA>> {
        const requestOptions = await this.antennasAReadAntennaARequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AntennaAFromJSON(jsonValue));
    }

    /**
     * Returns the A antenna specified by the given ID.
     * Get a single A antenna
     */
    async antennasAReadAntennaA(requestParameters: AntennasAReadAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AntennaA> {
        const response = await this.antennasAReadAntennaARaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for antennasAUpdateAntennaA without sending the request
     */
    async antennasAUpdateAntennaARequestOpts(requestParameters: AntennasAUpdateAntennaARequest): Promise<runtime.RequestOpts> {
        if (requestParameters['antennaAId'] == null) {
            throw new runtime.RequiredError(
                'antennaAId',
                'Required parameter "antennaAId" was null or undefined when calling antennasAUpdateAntennaA().'
            );
        }

        if (requestParameters['antennaAUpdate'] == null) {
            throw new runtime.RequiredError(
                'antennaAUpdate',
                'Required parameter "antennaAUpdate" was null or undefined when calling antennasAUpdateAntennaA().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/antennas_a/{antenna_a_id}`;
        urlPath = urlPath.replace('{antenna_a_id}', encodeURIComponent(String(requestParameters['antennaAId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AntennaAUpdateToJSON(requestParameters['antennaAUpdate']),
        };
    }

    /**
     * Update the A antenna specified by the given ID.
     * Update antenna A
     */
    async antennasAUpdateAntennaARaw(requestParameters: AntennasAUpdateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AntennaA>> {
        const requestOptions = await this.antennasAUpdateAntennaARequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AntennaAFromJSON(jsonValue));
    }

    /**
     * Update the A antenna specified by the given ID.
     * Update antenna A
     */
    async antennasAUpdateAntennaA(requestParameters: AntennasAUpdateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AntennaA> {
        const response = await this.antennasAUpdateAntennaARaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for antennasAValidateCreateAntennaA without sending the request
     */
    async antennasAValidateCreateAntennaARequestOpts(requestParameters: AntennasAValidateCreateAntennaARequest): Promise<runtime.RequestOpts> {
        if (requestParameters['antennaACreate'] == null) {
            throw new runtime.RequiredError(
                'antennaACreate',
                'Required parameter "antennaACreate" was null or undefined when calling antennasAValidateCreateAntennaA().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/antennas_a/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AntennaACreateToJSON(requestParameters['antennaACreate']),
        };
    }

    /**
     * Validate data for a new A antenna without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an ELOshield antenna A
     */
    async antennasAValidateCreateAntennaARaw(requestParameters: AntennasAValidateCreateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.antennasAValidateCreateAntennaARequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new A antenna without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate an ELOshield antenna A
     */
    async antennasAValidateCreateAntennaA(requestParameters: AntennasAValidateCreateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.antennasAValidateCreateAntennaARaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for antennasAValidateUpdateAntennaA without sending the request
     */
    async antennasAValidateUpdateAntennaARequestOpts(requestParameters: AntennasAValidateUpdateAntennaARequest): Promise<runtime.RequestOpts> {
        if (requestParameters['antennaAId'] == null) {
            throw new runtime.RequiredError(
                'antennaAId',
                'Required parameter "antennaAId" was null or undefined when calling antennasAValidateUpdateAntennaA().'
            );
        }

        if (requestParameters['antennaAUpdate'] == null) {
            throw new runtime.RequiredError(
                'antennaAUpdate',
                'Required parameter "antennaAUpdate" was null or undefined when calling antennasAValidateUpdateAntennaA().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/antennas_a/{antenna_a_id}/validate`;
        urlPath = urlPath.replace('{antenna_a_id}', encodeURIComponent(String(requestParameters['antennaAId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AntennaAUpdateToJSON(requestParameters['antennaAUpdate']),
        };
    }

    /**
     * Validate data for updating the given A antenna, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate A antenna update
     */
    async antennasAValidateUpdateAntennaARaw(requestParameters: AntennasAValidateUpdateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.antennasAValidateUpdateAntennaARequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given A antenna, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate A antenna update
     */
    async antennasAValidateUpdateAntennaA(requestParameters: AntennasAValidateUpdateAntennaARequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.antennasAValidateUpdateAntennaARaw(requestParameters, initOverrides);
    }

}
